import type { ReactNode } from 'react';

export const symbol_brick: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-205v-384q0-18.75 13.13-31.88Q106.25-634 125-634h78v-121q0-18.75 13.13-31.88Q229.25-800 248-800h135q18.75 0 31.88 13.12Q428-773.75 428-755v121h104v-121q0-18.75 13.13-31.88Q558.25-800 577-800h135q18.75 0 31.88 13.12Q757-773.75 757-755v121h78q18.75 0 31.88 13.12Q880-607.75 880-589v384q0 18.75-13.12 31.87Q853.75-160 835-160H125q-18.75 0-31.87-13.13Q80-186.25 80-205Zm60-15h680v-354H140v354Zm123-414h105v-106H263v106Zm329 0h105v-106H592v106ZM140-220h680-680Zm123-414h105-105Zm329 0h105-105Z"
		/>
	</svg>
);
